export default class InstitutionLinkStatuses {
  static ONLINE = "online";

  static OFFLINE = "offline";

  static PENDING = "pending";
}
